import React, {useEffect} from 'react';
import {ErrorBoundary} from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";

import phpVars from 'phpVars';

import './LoginPage.scss' ;
import LoginForm from "./LoginForm";

const LoginPage = (props) =>
{
    useEffect(()  => {
        document.body.classList.add('bg-login');

        return () => {
            document.body.classList.remove('bg-login');
        };
    });

    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
            <div className='login-container'>
            <LoginForm useProvider={false} mode={phpVars.action} reason={phpVars.reason} username={phpVars.username} token={phpVars.token} defaultLogo={'/images/logos/arcboxlogo.png'}/>
            { /* <SlateEditor /> */}
            </div>
        </ErrorBoundary>
    )
}

export default LoginPage;
